export default "__VITE_ASSET__B5vP2NO$__"